<template>
  <el-tooltip :content="content" v-bind="attrs">
    <apex-button v-bind="$attrs" v-on="$listeners">
      <slot />
    </apex-button>
  </el-tooltip>
</template>

<script>
export default {
  name: 'ApexTipButton',
  props: {
    content: {
      type: String,
      required: true
    },
    tipConfig: {
      type: Object,
      default: null
    }
  },
  computed: {
    attrs() {
      return {
        effect: 'dark',
        placement: 'top',
        ...this.tipConfig
      }
    }
  }
}
</script>
